import { Component, OnInit, Input } from '@angular/core';

import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import {MatTableDataSource} from '@angular/material/table';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_resultados35 } from 'app/idiomas/i18n/resultados35/resultados35.lang';

export interface PeriodicElement {
  nombre: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {nombre: 'Jose Perez Lopez'},
  {nombre: 'Yesenia Flores Gomez'},
  {nombre: 'Julio Marquez Rodriguez'},
  {nombre: 'Maria Guzman Flores'},
  {nombre: 'Aarón Martinez Gomez'},
  {nombre: 'Juan Carlos Lopez Roque'},
  {nombre: 'Josue Hernandez'},
  {nombre: 'Aline Morante Morales'},
];

@Component({
  selector: 'app-no-respondieron',
  templateUrl: './no-respondieron.component.html',
  styleUrls: ['./no-respondieron.component.scss']
})
export class NoRespondieronComponent implements OnInit {
  @Input() productoID: any;
  @Input() centroDeTrabajoId:any;
  displayedColumns: string[] = ['nombre'];
  dataSource = ELEMENT_DATA;
  tablaNoRespondieron: MatTableDataSource<backInter.GeneralesCentrosDeTrabajo>;
  urlCTIndividual:any;
  cargando:boolean=true;
  validarColaboradores:boolean=false;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService
  ) {
    lang_resultados35.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.getGeneralesCT();
  }

  getGeneralesCT(){
    let data={
      productoId: this.productoID,
      id_CT:this.centroDeTrabajoId
    }
    if(localStorage.getItem('empresaPadre')){
      this.urlCTIndividual=localStorage.getItem('empresaPadre');
    }
    else{
      this.urlCTIndividual="";
    }

    this.wizardService.getGeneralesCT(this.urlCTIndividual, data).subscribe( (datos: backInter.GeneralesCentrosDeTrabajo) => {
      console.log(datos);
      this.tablaNoRespondieron = new MatTableDataSource(datos.arrayNoAcept);
      if(datos.arrayNoAcept.length>0){
        this.validarColaboradores=true;
      }
      this.cargando=false;
    });
  }

}
